module.exports = __webpack_public_path__ + "img/biote-loader.1248c913.svg";